import { TZDate } from '@date-fns/tz';

const getTimeZoneOffsetInMin = (timeZone: string, date: Date) => {
  // A TZDate instance's getTimezoneOffset() follows the JS convention (minutes, positive = behind
  // UTC); negate to keep the "positive = ahead of UTC" contract callers rely on.
  return -new TZDate(date, timeZone).getTimezoneOffset();
};

window.getTimeZoneOffsetInMin = getTimeZoneOffsetInMin;

export default getTimeZoneOffsetInMin;
